module.exports = __webpack_public_path__ + "img/ysgj_004@2x.447b69e8.png";